import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface AuthorizationRequestedProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onAuthorizationReceived: () => unknown
  extensionActions?: ReactNode
}

export function AuthorizationRequestedProgressionActions({
  isAnyExtensionFlowAvailable,
  onAuthorizationReceived,
  extensionActions,
}: AuthorizationRequestedProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Authorization Received"
          variant="primary"
          size="wide-slim"
          onPress={onAuthorizationReceived}
          testId="job-progression-set-authorization-received-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
